import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';
import * as Accordion from '@radix-ui/react-accordion';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

const ResultContainer = styled.div`
  display: grid;
  width: 100%;
  place-items: center;
`;

const SortButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

const DropDown = styled(DropdownMenu.Content)`
  border-radius: 3px;
  padding: 10px 13px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid var(--light-grey, #cbcbcb);
  background: #fff;
  box-shadow: 0px 1px 6px 0px rgba(27, 27, 27, 0.15);
`;

const DropDownItem = styled(DropdownMenu.Item)`
  display: grid;
  height: 24px;
  grid-template-columns: 22px 1fr;
  grid-column-gap: 6px;
  align-items: center;
  cursor: pointer;
`;

const DropDownItemText = styled(UIElements.B2)`
  grid-area: 1/ 2;
`;

const ResultInner = styled(Accordion.Root)<{ paddingbottom?: number }>`
  width: 850px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: ${(props) => props.paddingbottom || 0}px;
`;

const Body = styled(Accordion.Item)`
  border-radius: 4px;
  border: 1px solid #cbcbcb;
  box-shadow: 0px 1px 6px 0px rgba(27, 27, 27, 0.05);
`;

const Header = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid #cbcbcb;
`;

const FlexRow = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;
`;

const BodyInner = styled(Accordion.Content).attrs({ forceMount: true })`
  padding: 24px 24px 29px 24px;
  display: grid;
  gap: 16px;

  &[data-state='closed'] {
    display: none;
  }
`;

const Footer = styled.section`
  display: flex;
  gap: 24px;
  flex-grow: 1;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const S = {
  ...UIElements,
  ResultContainer,
  ResultInner,
  Body,
  Footer,
  Header,
  BodyInner,
  FlexRow,
  TitleRow,
  SortButton,
  DropDown,
  DropDownItemText,
  DropDownItem,
};
